namespace $.$$ {

	export class $shm_wordstat_table extends $.$shm_wordstat_table {

		table() {
			return super.table() as $shm_wordstat_data_table | null
		}

		@ $mol_mem
		records() {
			return this.table()?.rows ?? []
		}

		@ $mol_mem
		col_ids() {
			return this.table()?.head.map( ( _, index )=> String( index ) ) ?? []
		}

		col_head_content( id: string ) {
			return [ this.table()?.head[ Number( id ) ] ?? '' ]
		}

		col_width( id: string ) {
			const title = this.table()?.head[ Number( id ) ] ?? ''
			return ({
				'Запрос': '170px',
				'Кол-во': '100px',
				'Регион': '180px',
				'С': '110px',
				'По': '110px',
				'Периодичность': '150px',
				'Устройство': '150px',
				'Wordstat': '100px',
				'Готово': '100px',
			} as Record< string, string >)[ title ] ?? '160px'
		}

		cell_width( id: { row: string[], col: string } ) {
			return this.col_width( id.col )
		}

		cell_content( id: { row: string[], col: string } ) {
			const row_id = id.row[ id.row.length - 1 ]
			const row = this.records()[ Number( row_id ) ] ?? []
			if( this.table()?.head[ Number( id.col ) ] === 'Wordstat' ) return [ this.Cell_link( row_id ) ]
			const value = String( row[ Number( id.col ) ] ?? '' )
			const column = this.table()?.head[ Number( id.col ) ]
			return [ column === 'С' || column === 'По' || column === 'Дата' ? this.$.$shm_date.text( value ) : value ]
		}

		cell_link_uri( row_id: string ) {
			const table = this.table()
			const row = this.records()[ Number( row_id ) ] ?? []
			const query = String( row[ table?.head.indexOf( 'Запрос' ) ?? -1 ] ?? '' )
			const region_value = String( row[ table?.head.indexOf( 'Wordstat' ) ?? -1 ] ?? '' )
			const region = !region_value || region_value === 'Все' ? 'all' : region_value
			const params = new URLSearchParams({
				region,
				view: 'graph',
				words: query,
			})
			return `https://wordstat.yandex.ru/?${ params }`
		}

	}

}
